module.exports = __webpack_public_path__ + "static/media/download.057f6f82.svg";